import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Packages from "./components/Packages";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "./components/PageNotFoud";
import Forms from "./components/Forms";
import Facilities from "./components/Facilities";
import PackageDetails from "./components/PackageDetails";
import ChristmasFeatures from "./components/ChristmasFeatures";

function App() {
  return (
    <>
      <main className="container-fluid ">
        <section className="row ">
          <ChristmasFeatures />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/facilities" element={<Facilities />} />
            <Route path="/forms" element={<Forms />} />
            <Route path="/package-details" element={<PackageDetails />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </section>
      </main>
    </>
  );
}

export default App;
